/* SilverShine — ss-entregas: video en el marco de foto.
   Spec (ESTADO.md 15-jul): video al hover en desktop; en móvil al quedar
   la tarjeta centrada en el carrusel (IntersectionObserver). Un solo video
   reproduciéndose a la vez, mudo, loop, preload="none". */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var current = null;

  function stop(card) {
    if (!card) return;
    var video = card.querySelector('video');
    card.classList.remove('is-playing');
    if (video) video.pause();
    if (current === card) current = null;
  }

  function play(card) {
    var video = card.querySelector('video');
    if (!video) return;
    if (current && current !== card) stop(current);
    current = card;
    card.classList.add('is-playing');
    var p = video.play();
    if (p && p.catch) p.catch(function () { stop(card); });
  }

  function initNav(section) {
    var track = section.querySelector('.ss-entregas__track');
    if (!track) return;
    var prev = section.querySelector('[data-ss-prev]');
    var next = section.querySelector('[data-ss-next]');

    function step() {
      var card = section.querySelector('.ss-entregas__card');
      return card ? (card.offsetWidth + 16) * 2 : 600;
    }
    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var progress = section.querySelector('[data-ss-progress]');
    function updateProgress() {
      if (!progress) return;
      var max = track.scrollWidth - track.clientWidth;
      var pct = max > 0 ? (track.scrollLeft / max) * 100 : 0;
      progress.style.width = Math.max(8, pct) + '%';
    }
    updateProgress();
    track.addEventListener('scroll', function () { updateArrows(); updateProgress(); }, { passive: true });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });
    updateArrows();

    /* Arrastre con el mouse (desktop) */
    var isDown = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      isDown = true;
      startX = e.clientX;
      startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      track.scrollLeft = startLeft - (e.clientX - startX);
    });
    window.addEventListener('pointerup', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    });
  }

  /* Orden "más reciente primero": Liquid no puede ordenar metaobjetos
     (sort falla sobre .values), así que ordenamos las tarjetas por data-fecha
     (YYYY-MM-DD, comparación lexicográfica = cronológica) descendente. */
  function sortByFecha(section) {
    var track = section.querySelector('.ss-entregas__track');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.ss-entregas__card'));
    cards.sort(function (a, b) {
      return (b.getAttribute('data-fecha') || '').localeCompare(a.getAttribute('data-fecha') || '');
    });
    cards.forEach(function (c) { track.appendChild(c); });
  }

  function initSection(section) {
    sortByFecha(section);
    initNav(section);
    var cards = section.querySelectorAll('.ss-entregas__card[data-has-video]');
    if (!cards.length) return;

    if (canHover.matches) {
      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () { play(card); });
        card.addEventListener('mouseleave', function () { stop(card); });
        card.addEventListener('focusin', function () { play(card); });
        card.addEventListener('focusout', function () { stop(card); });
      });
      return;
    }

    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

    var track = section.querySelector('.ss-entregas__track');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play(entry.target);
          } else if (entry.target === current) {
            stop(entry.target);
          }
        });
      },
      { root: track, rootMargin: '0px -25% 0px -25%', threshold: 0.3 }
    );
    cards.forEach(function (card) { observer.observe(card); });
  }

  function initAll() {
    document.querySelectorAll('.ss-entregas').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ss-entregas');
    if (section) initSection(section);
  });
})();
